import { Component, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Validators, FormGroup, FormControl, AbstractControl, ValidatorFn } from '@angular/forms';
import { MatDialogRef, MatDialog, MatInput} from '@angular/material';
import { TechnologyoverlayService } from '../technologyoverlay.service';
import { Subscription, Subject } from 'rxjs';
import { ApiService } from '../../../api.service';
import { takeUntil } from 'rxjs/operators';
import { getCampus, getCampusdetails, getBuilding, getBuildingdetails, getZone, getFloordetails, getUnit, getUnitdetails } from '../../../api';
import { SessionCheck, generateAlertMessage, AuthFailedMessage} from '../../../app-general';
import {Router} from '@angular/router';

@Component({
  selector: 'app-device-advancefilter',
  templateUrl: './device-advancefilter.component.html',
  styleUrls: ['./device-advancefilter.component.scss']
})
export class DeviceAdvancefilterComponent implements OnInit {

  public deviceFilterForm : FormGroup;
  watcher: Subscription;
  Campusdetails : getCampusdetails[];
  Buildingdetails : getBuildingdetails[];
  Floordetails : getFloordetails[];
  Unitdetails : getUnitdetails[];
  columns = 4;
  firstcolumns = 2;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  devicefilterbool : boolean = true; 
  selectedCampusId;
  Unitdetails_all = [];
  selectedBuildingId = 0;
  selectedFloorId = 0;
  selectedUnitId = 0;
  
  constructor(mediaObserver: MediaObserver,private apiService: ApiService,private router: Router,public thisDialogRef: MatDialogRef<DeviceAdvancefilterComponent>,
    private technologyoverlayService: TechnologyoverlayService) { 
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 4;
         this.firstcolumns = 1;         
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 4;
         this.firstcolumns = 1;         
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 4;
         this.firstcolumns = 2;         
        }               
       else
       {
         this.columns = 4;
         this.firstcolumns = 2;                                         
       }
      }
    
    });
  }

  ngOnInit() {
    this.deviceFilterForm = new FormGroup({
      campus : new FormControl('', [Validators.required]),
      building : new FormControl(''),
      floor : new FormControl(''),
      unit : new FormControl(''), 
    })
    this.getCampusDetails(this.SiteId);
  }
  
  
getCampusDetails(sideid : string) 
{ 
  try
  {
    let campusid: getCampus = {
      siteId : sideid,
      authKey: localStorage.getItem("Authkey")
    }
    this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
    .subscribe((CampusDetails : any[])=>{  
      this.Campusdetails = CampusDetails["apiReturn"];
      
    });  
  }
  catch (err) {
    throw new Error('add-resident.component.ts' + ' - getCampusDetails() - ' + err.message);
  }
  
} 

getBuildingDetails(CampusId)
{
  try
  {
    this.selectedCampusId = CampusId;
    let buildingid: getBuilding = {      
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId : parseInt(CampusId)
    }
    this.apiService.getBuildingDetails(buildingid).pipe(takeUntil(this._onDestroy))
    .subscribe((BuildingDetails : any[])=>{
      this.Buildingdetails = BuildingDetails["apiReturn"];
    });  
  }
  catch (err) {
    throw new Error('device-advancefilter.component.ts' + ' - getBuildingDetails() - ' + err.message);
  }

}

getFloorDetails(BuildingId)
{  
  try
  {      
    this.selectedBuildingId = BuildingId;
    let floorid: getZone = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      campusId:this.selectedCampusId,
      buildId : parseInt(BuildingId),
      floorId : 0
    }
    this.apiService.getZoneDetails(floorid).pipe(takeUntil(this._onDestroy))
    .subscribe((FloorDetails : any[])=>{
      this.Floordetails = FloorDetails["apiReturn"];
    });  
  }
  catch (err) {
    throw new Error('add-resident.component.ts' + ' - getFloorDetails() - ' + err.message);
  }

}

getUnitDetails(FloorId)
{    
  try
  {
    var unitdata = [];
    let voiceLicense = localStorage.getItem("voice_license");
    this.selectedFloorId = FloorId;
    let unitid: getUnit = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      floorId : FloorId,
      isIndoor:1,
      isNeedIntercom:parseInt(voiceLicense),
      isSubZone : 0
    }
    this.apiService.getUnitDetails(unitid).pipe(takeUntil(this._onDestroy))
    .subscribe((UnitDetails : any[])=>{ 
      unitdata = UnitDetails["apiReturn"];
      this.Unitdetails_all = unitdata;         
      this.selectUnits_outdoor()    
    });  
  }
  catch (err) {
    throw new Error('add-resident.component.ts' + ' - getUnitDetails() - ' + err.message);
  }

}

selectUnits_outdoor()
{    
  try
  {
    var outdoorunitdata = [];
    this.Unitdetails = [];
    let voiceLicense = localStorage.getItem("voice_license");
    let unitid: getUnit = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),
      floorId : this.selectedCampusId,
      isIndoor:0,
      isNeedIntercom:parseInt(voiceLicense),
      isSubZone : 0
    }    
    this.apiService.getUnitDetails(unitid).pipe(takeUntil(this._onDestroy))
    .subscribe((outdoorUnitDetails : any[])=>{                         
      outdoorUnitDetails["apiReturn"].forEach(function (data) {
        if(data.devicecount > 0)
        {
          outdoorunitdata.push(data);
        }
      });
      
      this.Unitdetails = this.Unitdetails_all.concat(outdoorunitdata);      
    });  
  }
  catch (err) {
    throw new Error('add-resident.component.ts' + ' - selectUnits_outdoor() - ' + err.message);
  }

}

changeunit(unitdata)
{
 
  this.selectedBuildingId = unitdata.BuildId;
  this.selectedFloorId = unitdata.FloorId;
  this.selectedUnitId = unitdata.UnitId;
}

public onCloseCancel = () => {
     
  this.thisDialogRef.close('Cancel');
  if(!SessionCheck(this.router))
  {
      return;
  }
}

public hasError = (controlName: string, errorName: string) =>{
return this.deviceFilterForm.controls[controlName].hasError(errorName);
}

public FilterDevicedetails = (deviceFilterForm) => {    
  try
  {  
    if(!SessionCheck(this.router))
    {
        this.thisDialogRef.close('Cancel');
        return;
    }         
    (document.activeElement as HTMLTextAreaElement).blur();        
    if (this.deviceFilterForm.valid && this.devicefilterbool) {
      this.devicefilterbool = false;  
      this.loadDevicefilterdetials(deviceFilterForm);                   
    }
  }
  catch (err) {    
    throw new Error('device-advancedfilter.component.ts' + ' - FilterDevicedetails() - ' + err.message);
  }
} 

loadDevicefilterdetials(devicefilterformvalue)
{
  let filterdetails : any =
  {
    CampusId : devicefilterformvalue.campus,
    BuildingId : this.selectedBuildingId,
    FloorId : this.selectedFloorId,
    UnitId : this.selectedUnitId
  }
  this.thisDialogRef.close(filterdetails);  
}



}
